<template>
  <div class="related-to-page">
    <ul>
      <li :class="{ active: isActive('/motherline/overview') }"><router-link
          to="/motherline/overview">Overview</router-link></li>
      <li :class="{ active: isActive('/motherline/history') }"><router-link
          to="/motherline/history">History</router-link></li>
      <li :class="{ active: isActive('/motherline/distribution-map') }"><router-link
          to="/motherline/distribution-map">Distribution Map</router-link></li>
      <li :class="{ active: isActive('/motherline/migration-map') }"><router-link
          to="/motherline/migration-map">Migration Map</router-link></li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'MotherLineNavigation',
  computed: {
    // Access the current route
    currentRoute() {
      return this.$route.path;
    },
  },
  methods: {
    // Determine if the route matches the current path
    isActive(path) {
      return this.currentRoute === path;
    },
  },
};
</script>